<div class="pa-input">
  <label *ngIf="label" class="line-label" [for]="valueAccessor.inputId">
    <span class="required-asterisk" *ngIf="isRequired">
      <i class="pi pi-asterisk" style="font-size: 10px"></i>
    </span>
    <span>{{ label }}</span>
    <i
      *ngIf="tooltip"
      class="pi pi-question-circle"
      [pTooltip]="tooltip"
      hideDelay="300"
    ></i>
  </label>

  <p-autoComplete
    class="autocomplete"
    [formControl]="valueAccessor.control"
    [inputId]="valueAccessor.inputId"
    [placeholder]="placeholder"
    [suggestions]="filteredSuggestions"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [minLength]="1"
    [delay]="100"
    [multiple]="false"
    [dropdown]="false"
    [forceSelection]="false"
    [completeOnFocus]="false"
    [showClear]="shouldShowClear"
    [emptyMessage]="'Ничего не найдено'"
    [showEmptyMessage]="true"
    [appendTo]="modalHost"
    [overlayOptions]="overlayOptions"
    [ngClass]="{ 'ng-invalid ng-dirty': showErrors }"
    (completeMethod)="handleComplete($event)"
    (onSelect)="handleSelect($event)"
    (onBlur)="handleBlur()"
    (onHide)="handleHide()"
    (onClear)="handleClear()"
  >
    <ng-template let-item pTemplate="item">
      <div class="option-name" [ngClass]="{ 'line-through': item?.isDeleted }">
        {{ item?.[optionLabel] ?? item }}
      </div>
    </ng-template>
  </p-autoComplete>

  <small *ngIf="hint" [ngClass]="{ invalid: valueAccessor.control.invalid }">
    {{ hint }}
  </small>

  <div *ngIf="showErrors" class="error-messages">
    <div *ngFor="let error of errors" class="error-item">
      {{ getErrorMessage(error) }}
    </div>
  </div>
</div>

